import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-864833dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "lab" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "in-dev" }, "IN DEVELOPMENT", -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_router_view),
    _createElementVNode("div", {
      class: _normalizeClass(["text-h1 mt-after", { dev: _ctx.dev }])
    }, _hoisted_4, 2)
  ]))
}